import { actionTypes } from "./gameTypes"

const INITAL_STATE = {
    selected: null,
    computer: null,
    result: null,
    currentScore:Number(localStorage.getItem("score")) || 0
}

const gameReducer = (state = INITAL_STATE, { type, payload }) => {

    switch (type) {
        case actionTypes.SELECT_GAME_CHOICE:
            return ({
                ...state,
                selected: payload
            })
        case actionTypes.SELECT_COMPUTER_CHOICE:
            return ({
                ...state,
                computer: payload
            })
        case actionTypes.RESULT_DECICION:
            return ({
                ...state,
                result: payload
            })
        case actionTypes.SCORE_COMPUTAION:
    localStorage.setItem("score" , Number(state.currentScore) + payload)
            return ({
                ...state,
                currentScore: state.currentScore + payload
            })
        case actionTypes.FLUSH_STATE:
            return ({
                ...state,
                selected: null,
                computer: null,
                result: null,
            })
        default: return state
    }

}

export default gameReducer